import { Trans } from '@lingui/react/macro';
import { cn, cva, type VariantProps } from 'noddi-ui-common';
import { NoddiButton } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeading } from './PageHeading';

const recallContentWrapperVariants = cva('mx-auto mt-8 flex flex-col px-5 pb-28 sm:px-10 md:mt-14', {
  variants: {
    width: {
      md: 'max-w-2xl',
      lg: 'max-w-2xl md:max-w-screen-lg md:px-10'
    }
  },
  defaultVariants: {
    width: 'md'
  }
});

interface Props extends VariantProps<typeof recallContentWrapperVariants> {
  title?: string;
  subtitle?: string;
  className?: string;
  hideBackButton?: boolean;
}

export const RecallContentWrapper = ({
  children,
  title,
  subtitle,
  width,
  className,
  hideBackButton
}: PropsWithChildren<Props>) => {
  const hasContent = !!title || !!subtitle;
  const navigate = useNavigate();

  return (
    <div className={cn(recallContentWrapperVariants({ width }), className)}>
      {!hideBackButton && (
        <NoddiButton
          startIcon='ArrowLeft'
          onClick={() => {
            navigate(-1);
          }}
          variant='ghost'
          className='-ml-3.5'
        >
          <Trans>Back</Trans>
        </NoddiButton>
      )}
      {hasContent && (
        <div className='mb-4 flex flex-col gap-2 text-balance'>
          {title && (
            <PageHeading className='text-2xl font-bold text-primary md:text-3xl xl:text-4xl'>{title}</PageHeading>
          )}
          {subtitle && <p>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};
